import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "p-grid p-m-0 p-col-12 p-p-0 kn-height-full" }
const _hoisted_2 = { class: "p-col-4 p-sm-4 p-md-3 p-p-0 kn-height-full" }
const _hoisted_3 = {
  class: "kn-list-item",
  "data-test": "list-item"
}
const _hoisted_4 = { class: "kn-list-item-text" }
const _hoisted_5 = { class: "kn-list-item-text-secondary" }
const _hoisted_6 = { class: "p-col-8 p-sm-8 p-md-9 p-p-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_Badge = _resolveComponent("Badge")
  const _component_Listbox = _resolveComponent("Listbox")
  const _component_UseModeDetail = _resolveComponent("UseModeDetail")
  const _component_Card = _resolveComponent("Card")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_component_Card, { class: "p-col-12 kn-card kn-card-layout kn-tab-card" }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
        start: _withCtx(() => [
          _createVNode("span", null, _toDisplayString(_ctx.$t('managers.driversManagement.useModes.title')), 1)
        ]),
        end: _withCtx(() => [
          _createVNode(_component_Button, {
            label: _ctx.$t('managers.driversManagement.add'),
            class: "kn-button p-button-text",
            disabled: _ctx.disableActionButton,
            onClick: _ctx.showForm,
            "data-test": "add-action-button"
          }, null, 8, ["label", "disabled", "onClick"])
        ]),
        _: 1
      })
    ]),
    content: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_ProgressBar, {
                key: 0,
                mode: "indeterminate",
                class: "kn-progress-bar",
                "data-test": "progress-bar"
              }))
            : _createCommentVNode("", true),
          (!_ctx.loading)
            ? (_openBlock(), _createBlock(_component_Listbox, {
                key: 1,
                class: "kn-list kn-height-full",
                options: _ctx.modes,
                optionLabel: "label",
                onChange: _ctx.showForm,
                "data-test": "usemodes-list"
              }, {
                empty: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
                ]),
                option: _withCtx((slotProps) => [
                  _createVNode("div", _hoisted_3, [
                    (slotProps.option.numberOfErrors > 0 || slotProps.option.associatedRoles.length === 0)
                      ? (_openBlock(), _createBlock(_component_Badge, {
                          key: 0,
                          value: "!",
                          class: "p-ml-2",
                          severity: "danger"
                        }))
                      : _createCommentVNode("", true),
                    _withDirectives(_createVNode("div", _hoisted_4, [
                      _createVNode("span", null, _toDisplayString(slotProps.option.label), 1),
                      _createVNode("span", _hoisted_5, _toDisplayString(slotProps.option.name), 1)
                    ], 512), [
                      [
                        _directive_tooltip,
                        slotProps.option.description,
                        void 0,
                        { top: true }
                      ]
                    ]),
                    _createVNode(_component_Button, {
                      icon: "far fa-trash-alt",
                      class: "p-button-text p-button-rounded p-button-plain",
                      onClick: _withModifiers(($event: any) => (_ctx.deleteModeConfirm(slotProps.option)), ["stop"]),
                      "data-test": "delete-button"
                    }, null, 8, ["onClick"])
                  ])
                ]),
                _: 1
              }, 8, ["options", "onChange"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_UseModeDetail, {
            selectedMode: _ctx.selectedUseMode,
            selectionTypes: _ctx.selectionTypes,
            roles: _ctx.roles,
            constraints: _ctx.constraints,
            lovs: _ctx.lovs,
            disabledRoles: _ctx.disabledRoles,
            layers: _ctx.layers,
            isDate: _ctx.isDate,
            showMapDriver: _ctx.showMapDriver
          }, null, 8, ["selectedMode", "selectionTypes", "roles", "constraints", "lovs", "disabledRoles", "layers", "isDate", "showMapDriver"])
        ])
      ])
    ]),
    _: 1
  }))
}